/*
 * セールラベルの期間判定（SERRA-318）
 * snippets/sale-label.liquid が hidden で出力したラベルを、期間内のときだけ表示する。
 * 日時はテーマ設定の「YYYY-MM-DD HH:MM」（日本時間）。終了時刻はその分の59秒まで含める。
 * 日時が空・読めない場合は表示しない。
 */
(function () {
  var JST_OFFSET_HOURS = 9;

  function parseJst(value) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})\s*$/.exec(value || '');
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - JST_OFFSET_HOURS, +m[5]);
  }

  function isActive(el, now) {
    var start = parseJst(el.getAttribute('data-sale-start'));
    var end = parseJst(el.getAttribute('data-sale-end'));
    if (isNaN(start) || isNaN(end)) return false;
    return now >= start && now < end + 60 * 1000;
  }

  function apply() {
    var now = Date.now();
    var labels = document.querySelectorAll('[data-sale-label]');
    for (var i = 0; i < labels.length; i++) {
      var el = labels[i];
      var active = isActive(el, now);
      el.hidden = !active;
      // カード用は画像リンクの左上に重ねるため、親を配置の基準にする
      if (active && el.classList.contains('sale-label--card')) {
        var parent = el.parentElement;
        if (parent && window.getComputedStyle(parent).position === 'static') {
          parent.style.position = 'relative';
        }
      }
    }
  }

  // 絞り込み・並び替えなどで商品一覧が差し替わった場合にも判定し直す
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function init() {
    apply();
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    // 開いたまま開始・終了時刻をまたいだ場合に備え、1分ごとに判定し直す
    window.setInterval(apply, 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
